import { get } from 'lodash';
import {
  ROLE_WIX_ARENA_MEMBER,
  ROLE_WIX_CODE_EXPERT,
  ROLE_WIX_CODE_FORUM_NINJA,
  ROLE_WIX_COMMUNITY_CHAMP,
  ROLE_WIX_CON_MIAMI,
  ROLE_WIX_EXPERT,
  ROLE_WIX_TRIBE_LEADER,
} from '../../common/components/permissions-context/permissions-checker';

const badgeRoles = [
  ROLE_WIX_EXPERT,
  ROLE_WIX_CODE_EXPERT,
  ROLE_WIX_ARENA_MEMBER,
  ROLE_WIX_CODE_FORUM_NINJA,
  ROLE_WIX_TRIBE_LEADER,
  ROLE_WIX_COMMUNITY_CHAMP,
  ROLE_WIX_CON_MIAMI,
];

export const getUserBadges = user => get(user, 'rolesList', []).filter(r => badgeRoles.includes(r));
